import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AuthPage from "./pages/AuthPage/AuthPage";
import Home from "./pages/Home/Home";
import AdicionarMedicamento from "./pages/AdicionarMedicamento/AdicionarMedicamento";
import Perfil from "./pages/Perfil/Perfil";
import Relatorio from "./pages/Relatorio/Relatorio";
import Dispositivo from "./pages/Dispositivo/Dispositivo";
import Layout from "./components/Layout/Layout";
import ProtectedRoute from "./services/ProtectedRoute";
import "./style/theme.scss";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AuthPage />} />
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Layout>
                <Home />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/adicionar-medicamento"
          element={
            <ProtectedRoute>
              <Layout>
                <AdicionarMedicamento />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dispositivo"
          element={
            <ProtectedRoute>
              <Layout>
                <Dispositivo />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/perfil"
          element={
            <ProtectedRoute>
              <Layout>
                <Perfil />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/relatorio"
          element={
            <ProtectedRoute>
              <Layout>
                <Relatorio />
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
